export default __webpack_public_path__ + "static/media/calendario-dark.8f746e0b.svg";